module.exports = __webpack_public_path__ + "img/3.245a1c66.svg";